const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function logoSrc(company) {
  if (!company?.logo_url) return null;
  return company.logo_url.startsWith("http") ? company.logo_url : `${BACKEND}${company.logo_url}`;
}

function initials(name = "") {
  const parts = name.replace(/[^a-zA-Z0-9 ]/g, "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "•";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function CompanyBadge({ company, size = 32, className = "" }) {
  const src = logoSrc(company);
  const color = company?.color || "#D4AF37";
  const style = { width: size, height: size, minWidth: size };
  if (src) {
    return (
      <img src={src} alt={company?.name || "logo"} style={style}
        className={`rounded-lg object-cover ${className}`} data-testid="company-logo" />
    );
  }
  return (
    <div style={{ ...style, background: `${color}22`, color, borderColor: `${color}55` }}
      className={`flex items-center justify-center rounded-lg border text-[11px] font-bold tracking-tight ${className}`}
      data-testid="company-monogram">
      {initials(company?.name)}
    </div>
  );
}
